import { Box, Divider } from "@mui/material";
import { DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { FilterOption } from "../FilterPopover.types.ts";
import React from "react";
import SubMenuList from "./SubMenuList.tsx";
import { TextFieldWrapper } from "../FilterPopover.tsx";
import { GetRecurrenceData } from "./SubMenuDataHelper.ts";

export enum RecurrenceFilterEnum {
    OneTime = 1,
    UnderAMonth = 2,
    OneMonth = 3,
    ThreeMonths = 5,
    SixMonths = 6,
    TwelveMonths = 7,
    TwoYears = 8,
}

export interface RecurrenceFieldValue {
    from: number | undefined;
    to: number | undefined;
    recurrenceFilterEnum: RecurrenceFilterEnum | undefined;
}

export interface RecurrenceFieldSubMenuProps {
    selectedOption: FilterOption;
    onChange: (value: RecurrenceFieldValue) => void;
    onLeftArrowClick?: () => void;
    submenuInputRef: React.RefObject<HTMLInputElement>;
}

function RecurrenceFieldSubMenu(props: RecurrenceFieldSubMenuProps) {
    const { onChange, submenuInputRef } = props;
    const { translateString } = useTranslation();

    const data = [
        { id: RecurrenceFilterEnum.OneTime.toString(), name: translateString("oneTimeActivity") },
        { id: RecurrenceFilterEnum.UnderAMonth.toString(), name: translateString("underAMonth") },
        { id: RecurrenceFilterEnum.OneMonth.toString(), name: translateString("everyMonth") },
        { id: RecurrenceFilterEnum.ThreeMonths.toString(), name: translateString("repertEveryXMonth", { repetition: 3 }) },
        { id: RecurrenceFilterEnum.SixMonths.toString(), name: translateString("repertEveryXMonth", { repetition: 6 }) },
        { id: RecurrenceFilterEnum.TwelveMonths.toString(), name: translateString("repertEveryXMonth", { repetition: 12 }) },
        { id: RecurrenceFilterEnum.TwoYears.toString(), name: translateString("recurEveryXYear", { repetition: 2 }) },
    ];

    const value = GetRecurrenceData(props.selectedOption.value);

    const onRangeChange = (from: number | undefined, to: number | undefined) => {
        onChange({ from: from, to: to, recurrenceFilterEnum: undefined });
    };

    const onEnumChange = (enumValue: string) => {
        if (value.recurrenceFilterEnum === Number(enumValue)) {
            onChange({ recurrenceFilterEnum: undefined, from: undefined, to: undefined });
        } else {
            onChange({ recurrenceFilterEnum: Number(enumValue), from: undefined, to: undefined });
        }
    };

    return (
        <Box>
            <TextFieldWrapper>
                <DotLegalTextField
                    label={`${translateString("from")} (${translateString("numberOfMonths")})`}
                    value={value.from?.toString() ?? null}
                    debounce={false}
                    onlyNumber="integer"
                    onChange={(from) => onRangeChange(from ? parseInt(from) : undefined, value.to)}
                    noMargin
                />
                <DotLegalTextField
                    label={`${translateString("to")} (${translateString("numberOfMonths")})`}
                    value={value.to?.toString() ?? null}
                    debounce={false}
                    onlyNumber="integer"
                    onChange={(to) => onRangeChange(value.from, to ? parseInt(to) : undefined)}
                    noMargin
                />
            </TextFieldWrapper>

            <Divider />

            <SubMenuList
                submenuInputRef={submenuInputRef}
                data={data}
                onChange={(clickedOption) => {
                    onEnumChange(clickedOption.id);
                }}
                onLeftArrowClick={props.onLeftArrowClick}
                chosenValues={value.recurrenceFilterEnum ? [data.find((x) => x.id === value.recurrenceFilterEnum!.toString())!] : []}
            />
        </Box>
    );
}

export default RecurrenceFieldSubMenu;
